// extracted by mini-css-extract-plugin
module.exports = {"button":"CartButton_button__wGZ6b","badge":"CartButton_badge__3seHF","badgeText":"CartButton_badgeText__DERbR"};